import {
  Avatar,
  Box,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleSearchIcon, PurpleX } from 'Images';
import { RefObject } from 'react';

interface SearchInputProps {
  value: string;
  inputRef: RefObject<HTMLInputElement | null>;
  useCurtain: boolean;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onClear: () => void;
}

export const SearchInput = ({
  value,
  inputRef,
  useCurtain,
  onInputChange,
  onKeyDown,
  onClear,
}: SearchInputProps) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.ActivitiesLobby);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={{
        width: isDesktop ? '564px' : undefined,
        height: '56px',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        bgcolor: 'white',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '30px',
        cursor: 'text',
        position: 'relative',
        px: '4px',
      }}
    >
      <Avatar
        sx={{ width: '44px', height: '44px' }}
        src={PurpleSearchIcon}
        alt=''
      />
      {value.length > 0 && (
        <IconButton sx={{ p: '4px' }} onClick={onClear}>
          <Avatar
            sx={{ width: '20px', height: '20px', cursor: 'pointer' }}
            src={PurpleX}
            alt={Dictionary[DICTIONARY.General].clearSearch}
            aria-label={Dictionary[DICTIONARY.General].clearSearch}
          />
        </IconButton>
      )}
      <Box
        sx={{
          flex: 1,
          position: 'relative',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <legend
          style={{
            position: 'absolute',
            width: 1,
            height: 1,
            overflow: 'hidden',
          }}
        >
          {dictionary.searchButton}
        </legend>
        {value.length === 0 && useCurtain && (
          <Typography
            component='span'
            variant='body3'
            sx={{
              position: 'absolute',
              right: 0,
              pr: 2,
              color: 'text.secondary',
              pointerEvents: 'none',
            }}
          >
            {dictionary.searchInfoOrActions}
          </Typography>
        )}
        <TextField
          inputRef={inputRef}
          sx={{
            width: '100%',
            pl: 2,
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '& .MuiInputBase-input': {
              textAlign: 'right',
              marginRight: '16px',
            },
          }}
          inputProps={{
            style: { padding: 0 },
            'aria-label': dictionary.searchInfoOrActions,
          }}
          value={value}
          onChange={onInputChange}
          onKeyDown={onKeyDown}
        />
      </Box>
    </Stack>
  );
};
